import { observable, configure, action } from 'mobx';
import util from 'preact-util';

configure({ enforceActions: 'always' });

class ImageBrowserStore {
    @observable images = [];
    @observable loading = false;
    @observable total = 0;
    @observable source = '';
    @observable search = '';
    @observable userFilter = '';

    @action
    updateKeyValue(key, value) {
        this[key] = value;
    }

    @action
    async loadImages({ source, search, user, limit = 50, offset = 0, append = false } = {}) {
        this.loading = true;
        const params = { limit, offset };
        if (source) {
            params.source = source;
        }
        if (search) {
            params.search = search;
        }
        if (user) {
            params.user = user;
        }

        const response = await util.fetchApi('/api/images/', { method: 'GET' }, params);
        if (response && response.status === 200) {
            if (append) {
                this.updateKeyValue('images', [...this.images, ...response.data]);
            } else {
                this.updateKeyValue('images', response.data);
            }
            this.updateKeyValue('total', response.total || 0);
        }
        this.updateKeyValue('loading', false);
    }

    @action
    reset() {
        this.images = [];
        this.total = 0;
        this.source = '';
        this.search = '';
        this.userFilter = '';
        this.loading = false;
    }
}

const store = new ImageBrowserStore();
export default store;
